import { ChangeDetectorRef, Component } from '@angular/core';

import { FormBuilder, FormGroup, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { ApiCallService } from '../services/api-call.service';
import { UtilService } from '@app/shared/services/util.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { GetAllService } from '@app/shared/table/getAll.service';

@Component({
    imports: [FormsModule, ReactiveFormsModule, SharedModule, RouterModule],
    selector: 'app-generate-key',
    templateUrl: './generate-key.component.html',
    styleUrls: ['./generate-key.component.css']
})
export class GenerateKeyComponent {
  today: string;
  form: FormGroup;
  modules = ['dashboard', 'customer', 'library', 'operations', 'users', 'finance']; // example modules
  
  showRoleModal = false;
  isLoading = true;
  availableRoles = []; // example roles
  selectedRoles: string[] = [];

  toggleRole(role: string, checked: boolean) {
    if (checked) {
      this.selectedRoles.push(role);
    } else {
      this.selectedRoles = this.selectedRoles.filter(r => r !== role);
    }
  }

  confirmRoles() {
    if(this.selectedRoles.length === 0) {
      this.util.simpleDialog({
        title: 'error',
        message: "Select at least one role"
      });
      return;
    }
    this.showRoleModal = false;
  }

  cancelRoles() {
    this.showRoleModal = false;
    this.selectedRoles = []; // clear selection if needed
    this.router.navigate(['/dev-console']);
  }

  constructor(
    private fb: FormBuilder, 
    private apiKeyService: ApiCallService, 
    private router: Router, 
    private cdr: ChangeDetectorRef,
    private util: UtilService,
    private logger: LoggerService,
    private getAllService: GetAllService,
  ) {
    this.form = this.fb.group({
      usageLimit: [''],
      expiresAt: [''],
      roleAccess: this.fb.array(this.modules.map(() => this.fb.group({
        read: [false],
        add: [false],
        edit: [false],
        delete: [false]
      })))
    });
  }

  ngOnInit() {
    const now = new Date();
    this.today = now.toISOString().split('T')[0];
    this.getAllAdminRoles();
  }

  preventTyping(event: KeyboardEvent): void {
    event.preventDefault();
  }

  getAllAdminRoles() {
    this.getAllService.getAdminRoles().subscribe(
      (data: any) => {

        // Normalize and process the data
        this.availableRoles = Array.from(
          new Set(
            data.body.responseBody
              .filter(ele => ele.role_name !== "Default Access")
              .map(ele => ele.role_name)
          )
        );

        this.isLoading = false;
        this.showRoleModal = true;
        this.cdr.markForCheck(); // Update view

      },
      (err: any) => {
        this.isLoading = false;
        console.error('Error fetching admin roles:', err);
        this.logger.error('Error fetching admin roles:', err);
        this.cdr.markForCheck();
      }
    );
  }
  get roleAccess(): FormArray {
    return this.form.get('roleAccess') as FormArray;
  }
  

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      const payload = this.form.value;
      const roleAccessArray = payload.roleAccess;

      // build access object dynamically
      const access = { read: [], add: [], edit: [], delete: [] };

      roleAccessArray.forEach((group: any, index: number) => {
        const module = this.modules[index];
        if (group.read) access.read.push(module);
        if (group.add) access.add.push(module);
        if (group.edit) access.edit.push(module);
        if (group.delete) access.delete.push(module);
      });
      
      if (!payload.usageLimit) {
        this.util.simpleDialog({
          title: 'error',
          message: "Please enter valid usage limit"
        });
        return;
      }

      if (!payload.expiresAt) {
        this.util.simpleDialog({
          title: 'error',
          message: "Enter a valid expiry date"
        });
        return;
      }
      const postData = {
        access,
        usage_limit: payload.usageLimit,
        expires_at: payload.expiresAt,
        allowed_roles: this.selectedRoles
      }
      this.apiKeyService.createKey(postData).subscribe(
        (data: any) => {
         const response = data['body']['responseBody'];
         if (response) {
          this.isLoading=false;
          this.router.navigate(['/dev-console']);
           this.util.simpleDialog({
             title: 'success',
             message: "API Key generated successfully",
           });
          this.cdr.detectChanges();
         } else {
          this.util.simpleDialog({ 
            title : 'error', 
            message :"Unable to generate API Key"
          });
          this.cdr.detectChanges();
         }
       },
       (error) => {
        this.isLoading=false;
         console.error('Error creating API Key:', error);
         this.logger.error('Error creating API Key:', error);
         this.util.simpleDialog({
           title: 'error',
           message: error
         });
         this.cdr.detectChanges();
       }
      );
    }
  }
}